<template>
	<div class="tab-content">
		<template v-if="activeTab && activeTab.component">
			<keep-alive>
				<component
					:is="activeTab.component"
					:key="cacheKey"
					v-bind="activeTab.props"
					v-on="activeTab.listeners || {}"
				/>
			</keep-alive>
		</template>
		<div v-else class="empty-state">
		</div>
	</div>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
	tabs: {
		type: Array,
		default: () => [],
	},
	activeTabId: {
		type: String,
		default: null,
	},
});

const activeTab = computed(
	() => props.tabs.find((tab) => tab.id === props.activeTabId) || null,
);

const cacheKey = computed(() => {
	if (!activeTab.value) return 'empty-tab';
	const componentName =
		activeTab.value.component?.name ||
		activeTab.value.component?.__name ||
		activeTab.value.component?.displayName ||
		'component';
	// A tab can keep its first key when its item changes, as a new document's editor does when
	// its first save gives it an id: the editor stays as it is instead of opening afresh.
	const itemKey = activeTab.value.cacheKey ?? activeTab.value.itemId ?? '';
	return `${activeTab.value.id}-${componentName}-${itemKey}`;
});
</script>

<style scoped>
.tab-content {
	flex: 1 1 auto;
	min-height: 0;
	min-width: 0;
	background: var(--noc-background);
	overflow: auto;
}

.empty-state {
	padding: 24px;
	text-align: center;
	color: var(--text-color-secondary);
}
</style>
